import styled from 'styled-components';

import { EnforcePageWidth } from '@/layout/PageLayout';

export const StyledStepperContainer = styled(EnforcePageWidth)`
  position: sticky;
  bottom: 0.5rem;
  box-shadow: 0 0 20px 0 rgba(42, 42, 43, 0.25);
  background-color: ${(props) => props.theme.color.primaryLight};
  z-index: 1;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  max-width: 60rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  border-radius: ${(props) => props.theme.radius.md};

  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
  }
`;
export const StyledStepperItem = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;
